import {AEButton} from "./buttons";
import {AESVG} from "./svg";
import React from "react";
import {useIntl} from "react-intl";
import {useFormik} from "formik";
import {AEAutoComplete, AEInput} from "../../_metronic/_partials/controls";
import {useLocation} from "react-router-dom";
import {toAbsoluteUrl} from "../../_metronic/_helpers";
import {reportAction} from "../../redux/support/actions";

const REASONS = {
  FAKE_ACCOUNT: 'FAKE_ACCOUNT',
  SPAM: 'SPAM',
  FRAUD: 'FRAUD',
  MISLEADING_INFO: 'MISLEADING_INFO',
  OFFENSIVE: 'OFFENSIVE',
  EXTREMELY_VIOLENT: 'EXTREMELY_VIOLENT',
  VIOLENT_OF_YOUR_RIGHTS: 'VIOLENT_OF_YOUR_RIGHTS',
  OTHER: 'REASON.OTHER',
}

const reasons = Object.values(REASONS)


export const AEReport = ({path, reason = REASONS.OTHER, message}) =>{

  const location = useLocation()

  const {formatMessage} = useIntl()
  const formik = useFormik({
    initialValues: { reason, message },
    onSubmit: (values)=>{
      const { message, reason } = values

      reportAction({
        url: toAbsoluteUrl(path || location.pathname),
        message,
        reason
      })
      //todo
    }
  });


  return (
    <div className="card card-custom bg-white gutter-b">
      <div className="card-header border-0 pt-5">
        <h3 className="card-title">
          <span className="card-label font-weight-bold font-size-h4 text-dark-75">
            {formatMessage({id:'REPORT'})}
          </span>
        </h3>
        <div className="card-toolbar">
          <AEButton
            variant={"light"}
            fontWeight={"bolder"}
            size={"sm"}
            onClick={formik.handleSubmit}
          >
            {formatMessage({id:'SEND'})}
            <AESVG path={"/Communication/Send.svg"} variant={"primary"}/>
          </AEButton>
        </div>
      </div>
      <div className="card-body">
        <div className="tab-content">
          <div className="form-group mb-4">
            <AEAutoComplete
              label={'REASON'}
              name={"reason"}
              options={reasons}
              getOptionLabel={id=>formatMessage({id})}

              // borderless
              field={formik.getFieldProps('reason')}
              form={formik}
              validation={false}
              withFeedbackLabel={false}
              // className={'form-control-solid'}
            />

          </div>
          <div className="form-group">
            <AEInput
              type={"textarea"}
              rows={10}
              label={'DETAIL'}
              name={"message"}
              // borderless
              field={formik.getFieldProps('message')}
              form={formik}
              validation={false}
              withFeedbackLabel={false}
              />
            {/*<textarea*/}
            {/*  className="form-control border-0 form-control-solid pl-6 font-weight-bolder"*/}
            {/*  rows="4"*/}
            {/*  placeholder={formatMessage({id:'DETAIL'})}*/}
            {/*/>*/}
          </div>
        </div>
      </div>
    </div>
  )
}